import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface OaInstallmentOption {
    n: number;
    /** "4x de R$ 295,86" já formatado ou só o valor ("R$ 295,86") */
    amount: string;
    /** "total R$ 1.183,44", "sem juros", "última R$ 240,13" */
    note?: string;
    free?: boolean;
}

/** InstallmentPicker do DS (ORCA-1929): grade de parcelas. */
@Component({
    selector: 'oa-installment-picker',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="oa-inst" role="radiogroup" [attr.aria-label]="ariaLabel"
            [style.grid-template-columns]="columns ? 'repeat(' + columns + ', minmax(0, 1fr))' : null">
            <button *ngFor="let option of options; trackBy: trackByN" type="button" class="oa-inst__opt" role="radio"
                [attr.aria-checked]="option.n === value ? 'true' : 'false'" (click)="pick(option.n)">
                <span><b>{{ option.n }}x</b> de {{ option.amount }}</span>
                <small *ngIf="option.note" [class.oa-inst__free]="option.free">{{ option.note }}</small>
            </button>
        </div>
    `,
})
export class OaInstallmentPickerComponent {
    @Input() options: OaInstallmentOption[] = [];
    @Input() value?: number | null;
    @Input() columns?: number;
    @Input() ariaLabel = 'Parcelas';
    @Output() valueChange = new EventEmitter<number>();

    pick(n: number) {
        this.value = n;
        this.valueChange.emit(n);
    }

    trackByN(_: number, option: OaInstallmentOption) {
        return option.n;
    }
}
